// extracted by mini-css-extract-plugin
module.exports = {"menu":"Menu_menu__1t0i-","disabled":"Menu_disabled__c-Agp"};